import React from 'react';
import ReactDOM from 'react-dom';

import AntibodyMap from 'antibodies/antibody-map/AntibodyMap';
import AntibodyMapTabState from 'antibodies/antibody-map/AntibodyMapTabState';
import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export interface AntibodyMapTabProps {
  antibodyId: string;
}

function AntibodyMapTab(props: AntibodyMapTabProps): JSX.Element {
  return (
    <div className="react-tab-container">
      <AntibodyMap {...props} />
    </div>
  );
}

export default class AntibodyMapTabView extends BufferTabView<AntibodyMapTabState> {
  render(): this {
    renderToDOM(<AntibodyMapTab antibodyId={this.model.get('antibodyId')} />, this.el);
    return this;
  }

  remove(): Backbone.View<AntibodyMapTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

AntibodyMapTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
